// WebSocketNotifier.tsx - VERSION CORRIGÉE
import React, { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { websocketService } from '../services/transferService';
import { toast } from 'react-hot-toast';

const WebSocketNotifier: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const lastNotificationRef = useRef<string>('');
  const notificationTimeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (isAuthenticated && user?.merchant_code) {
      const merchantCode = user.merchant_code;
      
      console.log(`🎯 WebSocketNotifier: Connexion pour ${merchantCode}`);

      // Handler pour les transferts

        const handleTransferUpdate = (data: any) => {
            console.log('📨 WebSocketNotifier: Transfer update', data);

            // FILTRE CRITIQUE : Ne traiter que les notifications pour ce marchand
            if (data.merchant_code && data.merchant_code !== merchantCode) {
                console.log(`🚫 Notification ignorée - destinée à ${data.merchant_code}, nous sommes ${merchantCode}`);
                return;
            }
            
            // Vérifier si c'est la même notification que la dernière
            const notificationKey = `${data.reference}_${data.status}_${data.timestamp}`;
            
            if (notificationKey === lastNotificationRef.current) {
                console.log('🔄 Doublon ignoré:', notificationKey);
                return;
            }
            
            lastNotificationRef.current = notificationKey;
            
            // Afficher le toast
            showToastNotification(data);
            
            // Émettre l'événement pour le contexte de notification
            window.dispatchEvent(new CustomEvent('transferNotification', { 
                detail: {
                title: 'Transfer Status Update',
                message: data.message,
                status: data.status,
                reference: data.reference,
                timestamp: data.timestamp,
                merchant_code: data.merchant_code || merchantCode
                }
            }));
            
            // Réinitialiser après 3 secondes
            if (notificationTimeoutRef.current) {
                clearTimeout(notificationTimeoutRef.current);
            }
            notificationTimeoutRef.current = setTimeout(() => {
                lastNotificationRef.current = '';
            }, 3000);
        };

      // Handler ping
      const handlePing = () => {
        console.log('🏓 Ping WebSocket');
      };

      // Attacher les gestionnaires
      websocketService.on('transfer_status_update', handleTransferUpdate);
      websocketService.on('ping', handlePing);

      // Se connecter
      websocketService.connect(merchantCode);

      // Cleanup
      return () => {
        websocketService.off('transfer_status_update', handleTransferUpdate);
        websocketService.off('ping', handlePing);
        
        if (notificationTimeoutRef.current) {
          clearTimeout(notificationTimeoutRef.current);
        }
      };
    }
  }, [isAuthenticated, user?.merchant_code]);

  // Fonction pour afficher les toasts
  const showToastNotification = (data: any) => {
    const { reference, status, message } = data;
    
    const toastConfig = {
      duration: 5000,
      position: 'top-right' as const,
    };

    switch (status) {
      case 'SUCCESS':
        toast.success(`✅ Transfert ${reference} : ${message}`, toastConfig);
        window.dispatchEvent(new CustomEvent('refreshData'));
        break;
        
      case 'REJECTED':
        toast.error(`❌ Transfert ${reference} : ${message}`, toastConfig);
        window.dispatchEvent(new CustomEvent('refreshData'));
        break;
        
      case 'PENDING':
        toast(`⏳ Transfert ${reference} : ${message}`, {
          ...toastConfig,
          duration: 4000,
        });
        break;
        
      default:
        toast(`📋 Transfert ${reference} : ${message}`, toastConfig);
    }
  };

  return null;
};

export default WebSocketNotifier;